/* eslint-disable prefer-destructuring */
// NPM Imports
import React, { Component } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { Tooltip, Toastr, Button, Input } from "../../../revvComponents";

// Components Imports
import RecipientDocHeaderDownloadButton from "./RecipientDocHeaderDownloadButton";
// import RecipientDocHeaderInfoButton from "./RecipientDocHeaderInfoButton";
import RecipientDocHeaderRejectButton from "./RecipientDocHeaderRejectButton";
import RecipientDeclineBtn from "./RecipientDeclineBtn";
import RecipientEditSignBtn from "./RecipientEditSignBtn";
import SubmitDeclineConfirmation from "../../DocumentApprovalPopupNew/SubmitDeclineConfirmation";
import EsignAcceptRejectPopup from "./EsignAcceptRejectPopup";

// Actions Imports
import RevvSignActions from "../../../actions/RevvSign";
import { buttonClickEvent } from "../../../gtm/gtmutils";
import GTM_EVENTS from "../../../gtm/gtmevents";
import { AmplitudeUtils } from "../../../utils";

import { EVENTS } from "../../../constants";
import LZLoader from "../../../commonComponents/LZLoader";

// Destructuring
const { sendDocForSigning, resetDrawSignData, toggleDrawsignPopup } =
  RevvSignActions;
class RecipientDocHeaderMoreBtn extends Component {
  moreBtnWrapperRef = React.createRef();

  state = {
    showDropdown: false,
    isDocumentDeclined: false,
    reviewerEmailMessage: "",
    isRedirecting: false,
  };

  _handleDropdownToggle = () => {
    if (!this.state.showDropdown) {
      document.addEventListener(
        "click",
        this._handleDropdownOutsideClick,
        false,
      );
    } else {
      document.removeEventListener(
        "click",
        this._handleDropdownOutsideClick,
        false,
      );
    }
    this.setState(prevState => ({
      showDropdown: !prevState.showDropdown,
    }));
  };

  _handleDropdownOutsideClick = e => {
    const node = this.moreBtnWrapperRef.current;
    if (e.target.dataset.test === "recipientdocheaderbuttons-notes-icon") {
      this.setState({ showDropdown: false });
      document.removeEventListener(
        "click",
        this._handleDropdownOutsideClick,
        false,
      );
      return;
    }
    if (
      (node && node.contains(e.target)) ||
      e.target.dataset.test === "exportdocumentbtn-recipient-download-btn"
    ) {
      return;
    }
    this._handleDropdownToggle();
  };

  _handleDocumentDecline = () => {
    if (!this.state.isDocumentDeclined) {
      buttonClickEvent(GTM_EVENTS.SIGNINGCEREMONY_DECLINE_DOC_CLICK);
      AmplitudeUtils.amplitudeLogEventLZ(EVENTS.EVENT_NAMES.CLICK_DECLINE, {
        source: EVENTS.SOURCE_LZ.DOCUMENT_EDITOR,
        screen: EVENTS.SCREEN_LZ.SIGNING_PAGE,
        document_type: EVENTS.DOCUMENT_TYPE.PDF,
        document_origination: this.props.isLz
          ? EVENTS.DOCUMENT_ORIGINATION_LZ.LZ
          : EVENTS.DOCUMENT_ORIGINATION_LZ.REVV,
      });
    }
    this.setState(prevState => ({
      isDocumentDeclined: !prevState.isDocumentDeclined,
    }));
  };

  _changeReviewMessage = e => {
    this.setState({ reviewerEmailMessage: e.target.value });
  };

  _approveRejectDoc = () => {
    this.setState({ isRedirecting: true });
    AmplitudeUtils.amplitudeLogEventLZ(EVENTS.EVENT_NAMES.DECLINE_DOCUMENT, {
      source: EVENTS.SOURCE_LZ.DOCUMENT_EDITOR,
      screen: EVENTS.SCREEN_LZ.SIGNING_PAGE,
      document_type: EVENTS.DOCUMENT_TYPE.PDF,
      document_origination: this.props.isLz
        ? EVENTS.DOCUMENT_ORIGINATION_LZ.LZ
        : EVENTS.DOCUMENT_ORIGINATION_LZ.REVV,
    });
    const payload = {
      signer_response: this.state.reviewerEmailMessage,
    };
    this.props
      .sendDocForSigning(
        this.props.docID,
        this.props.sharingHash,
        payload,
        "reject",
      )
      .then(() => {
        this.setState(prevState => ({
          isDocumentDeclined: !prevState.isDocumentDeclined,
        }));
        // Now we need to redirect it back to document in case of self signer
        const url = window.location.href;
        let params = "";
        if (Array.isArray(url.split("?")) && url.split("?").length > 1) {
          params = url.split("?")[1];
        }
        let redirect_url = "";
        if (
          params &&
          Array.isArray(params.split("=")) &&
          params.split("=").length > 1
        ) {
          redirect_url = params.split("=")[1];
        }
        if (redirect_url) {
          window.location.href = `${redirect_url}?return=decline`;
        } else if (
          (this.props.isLz || this.props.isIntegrationOrg) &&
          this.props.redirectUrl
        ) {
          if (this.props.redirectUrl.includes("?")) {
            window.location.href = `${this.props.redirectUrl}&return=decline`;
          } else {
            window.location.href = `${this.props.redirectUrl}?return=decline`;
          }
        }
        this.setState({ isRedirecting: false });
      });
  };

  _editSign = () => {
    AmplitudeUtils.amplitudeLogEventLZ(
      EVENTS.EVENT_NAMES.CLICK_EDIT_SIGNATURE,
      {
        source: EVENTS.SOURCE_LZ.DOCUMENT_EDITOR,
        screen: EVENTS.SCREEN_LZ.SIGNING_PAGE,
        document_type: EVENTS.DOCUMENT_TYPE.PDF,
        document_origination: this.props.isLz
          ? EVENTS.DOCUMENT_ORIGINATION_LZ.LZ
          : EVENTS.DOCUMENT_ORIGINATION_LZ.REVV,
      },
    );
    this.props.toggleDrawsignPopup(true, null, "EDIT");
  };

  render() {
    if (this.state.isRedirecting) {
      return (
        <LZLoader
          className="self-sign-loader saving-document"
          label="Please wait while we process your document."
          theme="dark"
          fullScreen
        />
      );
    }
    return (
      <div
        className="recipientdocheader-morebtn-container"
        ref={this.moreBtnWrapperRef}>
        {/* ------- More button section ------- */}

        <span
          data-test="recipientdocheader-morebtn"
          className={`recipientdocheader-morebtn ${
            this.state.showDropdown ? "active" : ""
          } ${this.props.isMobileView ? "mobie-view-morebtn" : ""}`}
          onClick={this._handleDropdownToggle}
          onKeyPress={() => {}}
          role="button"
          tabIndex="0">
          <FontAwesomeIcon
            icon={["far", "ellipsis-h"]}
            className="recipientdocheader-morebtn-icon"
          />
        </span>
        {/* ------- Dropdown section ------- */}
        {this.state.showDropdown && (
          <div className="recipientdocheader-morebtn-dropdown">
            {/* -------- Notes, Attachments and Metalens buttons section-------- */}
            {this.props.children}

            {/* -------- Devider section-------- */}
            {this.props.isMobileView && (
              <div className="recipientdocheader-morebtn-devider" />
            )}

            {/* -------- Download button section-------- */}
            <div className="recipientdocheader-morebtn-dropdown-row">
              <RecipientDocHeaderDownloadButton
                data-test="recipientdocheaderdownloadbutton"
                isSharedDocument={this.props.isSharedDocument}
                sharingHash={this.props.sharingHash}
                usedFor="DROPDOWN"
                className={`inside-dropdown ${
                  !this.props.isMobileView ? "desktop-view" : ""
                }`}
                tooltipPlacement="left"
                isMobileView={this.props.isMobileView}
                docType={this.props.documentPageType}
                documnetID={this.props.docID}
                documentName={this.props.documentName}
                isLz={this.props.isLz}
              />
            </div>
            {this.props.documentPageType === "ESIGN_DOCUMENT" &&
              this.props.doc_stage === "SENT" &&
              !this.props.isSigned && (
                <div className="recipientdocheader-morebtn-dropdown-row">
                  <RecipientDeclineBtn
                    data-test="recipientdocheaderdeclinebutton"
                    isSharedDocument={this.props.isSharedDocument}
                    sharingHash={this.props.sharingHash}
                    usedFor="DROPDOWN"
                    className={`inside-dropdown ${
                      !this.props.isMobileView ? "desktop-view" : ""
                    }`}
                    tooltipPlacement="left"
                    isMobileView={this.props.isMobileView}
                    handleDocumentDecline={this._handleDocumentDecline}
                  />
                </div>
              )}
            {this.props.documentPageType === "ESIGN_DOCUMENT" &&
              this.props.doc_stage === "SENT" &&
              this.props.drawSignType &&
              !this.props.isSigned && (
                <div className="recipientdocheader-morebtn-dropdown-row">
                  <RecipientEditSignBtn
                    data-test="recipientdocheaderdeclinebutton"
                    isSharedDocument={this.props.isSharedDocument}
                    sharingHash={this.props.sharingHash}
                    usedFor="DROPDOWN"
                    className={`inside-dropdown ${
                      !this.props.isMobileView ? "desktop-view" : ""
                    }`}
                    tooltipPlacement="left"
                    isMobileView={this.props.isMobileView}
                    editSign={this._editSign}
                  />
                </div>
              )}

            {this.props.isDocRejectBtn && (
              <div className="recipientdocheader-morebtn-dropdown-row">
                <RecipientDocHeaderRejectButton
                  data-test="recipientdocheader-reject-button"
                  isMobileView={this.props.isMobileView}
                  className={!this.props.isMobileView ? "desktop-view" : ""}
                />
              </div>
            )}
            {/* -------- Decline button section-------- */}
            {this.props.isDeclinedBtnEnabled && (
              <div className="recipientdocheader-morebtn-dropdown-row">
                <RecipientDeclineBtn
                  data-test="recipientdocheaderdeclinebutton"
                  isSharedDocument={this.props.isSharedDocument}
                  sharingHash={this.props.sharingHash}
                  usedFor="DROPDOWN"
                  className={`inside-dropdown ${
                    !this.props.isMobileView ? "desktop-view" : ""
                  }`}
                  tooltipPlacement="left"
                  isMobileView={this.props.isMobileView}
                  handleDocumentDecline={this._handleDocumentDecline}
                />
              </div>
            )}

            {/* -------- Revv info button section only for mobile devices-------- */}
            {/* {this.props.isMobileView && (
              <div className="recipientdocheader-morebtn-dropdown-row">
                <RecipientDocHeaderInfoButton
                  data-test="recipientdocheaderinfobutton"
                  usedFor="DROPDOWN"
                  tooltipPlacement="left"
                  className="inside-dropdown"
                  isMobileView={this.props.isMobileView}
                  docType={this.props.documentPageType}
                  sharingHash={this.props.sharingHash}
                />
              </div>
            )} */}
          </div>
        )}
        {this.props.documentPageType === "ESIGN_DOCUMENT" &&
          this.state.isDocumentDeclined && (
            <EsignAcceptRejectPopup
              cancelPopup={this._handleDocumentDecline}
              approveRejectDoc={this._approveRejectDoc}
              showLoaderClicktoRecordMandatory={
                this.state.showLoaderClicktoRecordMandatory
              }
              reviewerEmailMessage={this.state.reviewerEmailMessage}
              emailMessage=""
              changeReviewMessage={this._changeReviewMessage}
            />
          )}
        {this.props.documentPageType !== "ESIGN_DOCUMENT" &&
          this.state.isDocumentDeclined && (
            <SubmitDeclineConfirmation
              view="decline"
              togglePopUp={this._handleDocumentDecline}
              updateMultipleState={() => {}}
              sharingHash={this.props.sharingHash}
              isSharing
              usedFor="recipient"
              isMobileView={this.props.isMobileView}
            />
          )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    doc_stage,
    isSigned,
    drawSignType,
    is_lz: isLz,
    is_integration_org: isIntegrationOrg,
    redirect_url: redirectUrl,
  } = state.RevvSignStore;
  return {
    isSigned,
    doc_stage,
    drawSignType,
    isLz,
    isIntegrationOrg,
    redirectUrl,
  };
};
const mapDispatchToProps = {
  sendDocForSigning,
  resetDrawSignData,
  toggleDrawsignPopup,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RecipientDocHeaderMoreBtn);
